module.exports = __webpack_public_path__ + "img/0425af4.png";